import { render, staticRenderFns } from "./sc.vue?vue&type=template&id=bbf3d6a0&"
import script from "./sc.vue?vue&type=script&lang=js&"
export * from "./sc.vue?vue&type=script&lang=js&"
import style0 from "./sc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports